// extracted by mini-css-extract-plugin
export default {"div":"Redirect_div__QY70a"};